import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=98273a24&scoped=true&"
var script = {}
import style0 from "./Start.vue?vue&type=style&index=0&id=98273a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98273a24",
  null
  
)

component.options.__file = "Start.vue"
export default component.exports